import { useQuery } from '@tanstack/react-query';
import { getNotificationPreferences } from '../../services/notifications';

interface Params {
  businessId?: string;
}

function useGetNotificationPreferences({ businessId }: Params = {}) {
  return useQuery({
    queryKey: ['notification-preferences', businessId],
    queryFn: () => getNotificationPreferences({ businessId }),
  });
}

export default useGetNotificationPreferences;
